import { useEffect, useState } from 'react';
import { API, Endpoints } from '@brg/api';

export const useDomainsPlatform = (enabled: boolean = true): Map<string, string> => {
  const [domainsMap, setDomainsMap] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    if (!enabled || domainsMap.size > 0) {
      return;
    }

    API.fetch(`${Endpoints.tagsMnePw}/api/Domain/GetAllDomains`, {})
      .then(res => res.json())
      .then((response: any[]) => {
        const map = new Map<string, string>();

        const processItem = (item: any) => {
          if (typeof item === 'string') {
            map.set(item, 'unknown');
            return;
          }

          const domainUrl = item?.url || item?.stage || item?.dev;
          if (!domainUrl) return;

          let hostname = domainUrl;
          try {
            hostname = new URL(`https://${domainUrl}`).hostname;
          } catch (e) {
            hostname = domainUrl;
          }

          map.set(hostname, item.platform || 'unknown');

          if (item?.domainId === 'sport.mediiia.com' || domainUrl === 'mediiia.com/sport') {
            map.set('sport.mediiia.com', item.platform || 'unknown');
          }
        };

        if (Array.isArray(response)) {
          response.forEach(processItem);
        }

        setDomainsMap(map);
      })
      .catch(() => {
        
      });
  }, [enabled, domainsMap.size]);

  return domainsMap;
};
import { useEffect, useState } from 'react';
import { API, Endpoints } from '@brg/api';

export const useDomainsPlatform = (enabled: boolean = true): Map<string, string> => {
  const [domainsMap, setDomainsMap] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    if (!enabled || domainsMap.size > 0) {
      return;
    }

    API.fetch(`${Endpoints.tagsMnePw}/api/Domain/GetAllDomains`, {})
      .then(res => res.json())
      .then((response: any[]) => {
        const map = new Map<string, string>();

        const processItem = (item: any) => {
          if (typeof item === 'string') {
            map.set(item, 'unknown');
            return;
          }

          const domainUrl = item?.url || item?.stage || item?.dev;
          if (!domainUrl) return;

          let hostname = domainUrl;
          try {
            hostname = new URL(`https://${domainUrl}`).hostname;
          } catch (e) {
            hostname = domainUrl;
          }

          map.set(hostname, item.platform || 'unknown');

          if (item?.domainId === 'sport.mediiia.com' || domainUrl === 'mediiia.com/sport') {
            map.set('sport.mediiia.com', item.platform || 'unknown');
          }
        };

        if (Array.isArray(response)) {
          response.forEach(processItem);
        }

        setDomainsMap(map);
      })
      .catch(() => {
        
      });
  }, [enabled, domainsMap.size]);

  return domainsMap;
};
